import { render, staticRenderFns } from "./reports.vue?vue&type=template&id=04f70ed4&scoped=true"
import script from "./reports.vue?vue&type=script&lang=js"
export * from "./reports.vue?vue&type=script&lang=js"
import style0 from "./reports.vue?vue&type=style&index=0&id=04f70ed4&prod&scoped=true&lang=css"
import style1 from "./reports.vue?vue&type=style&index=1&id=04f70ed4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04f70ed4",
  null
  
)

export default component.exports